import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Divider,
  Table,
  Steps,
  Spin,
  Tag,
  message,
} from "antd";
import {
  PhoneFilled,
  DiffOutlined,
  CodeSandboxOutlined,
  CarOutlined,
  CheckSquareOutlined,
  DropboxOutlined,
} from "@ant-design/icons";
import truckicon from "../../Images/truckicon.png";
import { withRouter } from "react-router";
import { withAppContext } from "../../store/contextStore";
import AppConfigs from "../../Config/AppConfig";
import { getDetails, add, update } from "../../api/Apis";
import moment from "moment";
import "./OrderDetails.css";
import { Storage } from "aws-amplify";
import { formatPhoneNumber } from "../commonFunctions";
import NumberFormat from "react-number-format";
import Docsample from "../../Images/pdf.jpg";

const { Step } = Steps;

class OrderDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      leadData: {},
      carrierData: {},
      deliveryImage: [],
      orderDocument: "",
      orgDetails: JSON.parse(localStorage.getItem("orgDetails")),
    };
  }

  componentDidMount() {
    this.setState({
      dataLoadingStatus: true,
    });
    getDetails(
      AppConfigs["entityNames"]["leads"],
      this.props.match.params.id
    ).then(async (result) => {
      if (result.success) {
        this.setState({
          leadData: result.data,
        });
        let deliveryImage = [];
        if (result.data.cartItems[0]?.orderDocument) {
          let image = await Storage.get(
            result.data.cartItems[0]?.orderDocument
          );
          this.setState({
            orderDocument: image,
          });
        }
        let imagepath = await Storage.get(
          this.state.leadData?.["leadDeliveryImage"]?.["delivery_pic"]
        );
        deliveryImage.push({ deliveredImage: imagepath });
        this.setState({
          deliveryImage: imagepath,
        });
        if (result["data"]["assignCarrier"]) {
          getDetails(
            AppConfigs["entityNames"]["registrations"],
            result.data["carrierId"]
          ).then(async (customerRes) => {
            if (customerRes.success) {
              this.setState({
                dataLoadingStatus: false,
                carrierData: customerRes.data,
              });
            } else {
              console.log(customerRes.errors);
              this.setState({
                dataLoadingStatus: false,
              });
            }
          });
        } else {
          this.setState({
            dataLoadingStatus: false,
          });
        }
      } else {
        console.log(result.errors);
        this.setState({
          dataLoadingStatus: false,
        });
      }
    });
  }

  reOrder = async () => {
    this.setState({
      dataLoadingStatus: true,
    });
    let cartItems = this.state.leadData["cartItems"]
      ? this.state.leadData["cartItems"]
      : this.state.leadData["items"];
    let data = {};
    if (cartItems.length > 1) {
      cartItems.map((item) => {
        data = {
          entityData: {
            productId: item["productId"],
            size: item["size"],
            measurementType: item["measurementType"],
            deliveryTruck: item["deliveryTruck"],
            quantity: item["quantity"],
            customerId: this.state.leadData["customerId"],
            orgId: this.state.leadData["orgId"],
          },
        };
        let existingCartData = JSON.parse(localStorage.getItem("cartData"));
        let checkProduct =
          existingCartData &&
          existingCartData.filter(
            (c) =>
              c.productId === item["productId"] &&
              item["measurementType"] === c.measurementType &&
              item["size"] === c.size
          );
        if (checkProduct && checkProduct.length > 0) {
          data["entityData"]["quantity"] =
            parseInt(checkProduct[0]["quantity"]) + parseInt(item["quantity"]);
          data["entityData"]["id"] = checkProduct[0]["id"];
        }
        add(AppConfigs["addItemToCart"], data).then((result) => {
          if (result.success) {
            if (result.data.status) {
              let cartData = result.data.data;
              cartData.map(async (item, index) => {
                item["image"] = await Storage.get(item["image"]);
                if (cartData.length === index + 1) {
                  this.props.context.setCartData(cartData);
                  localStorage.setItem("cartData", JSON.stringify(cartData));
                  message.success("Product added successfully To cart!");
                  window.location = "/app/stones/finishorder";
                }
              });
              this.setState({
                dataLoadingStatus: false,
              });
            } else {
              message.error(result.data.message);
              this.setState({
                dataLoadingStatus: false,
              });
            }
          } else {
            console.log(result.errors);
          }
        });
      });
    } else {
      data = {
        entityData: {
          productId: cartItems[0]["productId"],
          size: cartItems[0]["size"],
          measurementType: cartItems[0]["measurementType"],
          deliveryTruck: cartItems[0]["deliveryTruck"],
          quantity: cartItems[0]["quantity"],
          customerId: this.state.leadData["customerId"],
          orgId: this.state.leadData["orgId"],
        },
      };
      let existingCartData = JSON.parse(localStorage.getItem("cartData"));
      // let checkProduct = existingCartData.filter((c) => c.productId === this.props.match.params.id && this.state.measurementType === c.measurementType && this.state.stoneData[0]["size"] === c.size);
      let checkProduct =
        existingCartData &&
        existingCartData.filter(
          (c) =>
            c.productId === cartItems[0]["productId"] &&
            cartItems[0]["measurementType"] === c.measurementType &&
            cartItems[0]["size"] === c.size
        );
      if (checkProduct && checkProduct.length > 0) {
        data["entityData"]["quantity"] =
          parseInt(checkProduct[0]["quantity"]) +
          parseInt(cartItems[0]["quantity"]);
        data["entityData"]["id"] = checkProduct[0]["id"];
      }
      add(AppConfigs["addItemToCart"], data).then((result) => {
        if (result.success) {
          if (result.data.status) {
            let cartData = result.data.data;
            cartData.map(async (item, index) => {
              item["image"] = await Storage.get(item["image"]);
              if (cartData.length === index + 1) {
                this.props.context.setCartData(cartData);
                localStorage.setItem("cartData", JSON.stringify(cartData));
                message.success("Product added successfully!");
                window.location = "/app/stones/finishorder";
              }
            });
            this.setState({
              dataLoadingStatus: false,
            });
          } else {
            message.error(result.data.message);
            this.setState({
              dataLoadingStatus: false,
            });
          }
        } else {
          console.log(result.errors);
        }
      });
    }
  };

  editOrder = () => {
    this.props.history.push(
      "/app/stones/editorder/" + this.props.match.params.id
    );
  };

  cancelOrder = () => {
    this.setState({
      dataLoadingStatus: true,
    });
    let data = {
      entityData: {
        orderStatus: AppConfigs["CANCELLED"],
        cancelledTime: moment().valueOf(),
      },
    };
    update(
      AppConfigs["entityNames"]["leads"],
      this.props.match.params.id,
      data
    ).then((result) => {
      if (result.success) {
        message.success("Lead cancelled successfully");
        this.setState({
          leadData: result.data.data,
          dataLoadingStatus: false,
        });
      } else {
        this.setState({
          dataLoadingStatus: false,
        });
        console.log(result.errors);
      }
    });
  };

  getProductData = (cartItems) => {
    let productData = {};
    getDetails(
      AppConfigs["entityNames"]["products"],
      cartItems[0]["productId"]
    ).then(async (productRes) => {
      if (productRes.success) {
        productData = productRes.data;
        let checkProductSize = productData.sizes.filter(
          (size) => size.size === cartItems[0]["size"]
        );
        if (checkProductSize.length > 0) {
          this.submitReOrderReq(cartItems);
        } else {
          message.error("The product is no longer available");
          this.setState({
            dataLoadingStatus: false,
          });
          return;
        }
      } else {
        console.log(productRes.errors);
      }
    });
  };
  fileDownload = async (fileName) => {
    this.setState({
      dataLoadingStatus: true,
    });
    Storage.get(fileName, { download: true }).then((res) =>
      this.downloadBlob(res.Body, fileName)
    );
  };

  downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    this.setState({
      dataLoadingStatus: false,
    });
    return a;
  }

  render() {
    const columns = [
      {
        title: <div style={{ color: "gray" }}>Name</div>,
        dataIndex: "productName",
        key: "productName",
        render: (productName) => (
          <div style={{ color: "black" }}>{productName}</div>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Size</div>,
        dataIndex: "size",
        key: "size",
        render: (size) => <div style={{ color: "black" }}>{size}</div>,
      },
      {
        title: <div style={{ color: "gray" }}>Measurement</div>,
        dataIndex: "measurementType",
        key: "measurementType",
        render: (measurementType, record) => (
          <span>
            {/* <div style={{ color: "black" }}>{measurementType.charAt(0).toUpperCase() + measurementType.slice(1)}</div> */}
            <div style={{ color: "black" }}>
              {measurementType[0].toUpperCase() +
                measurementType.substring(1).toLowerCase()}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Quantity</div>,
        dataIndex: "quantity",
        key: "quantity",
        render: (quantity) => (
          <span>
            <div style={{ color: "black" }}>{quantity}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Price Per Tone</div>,
        dataIndex: "amount",
        key: "amount",
        render: (price, record) => (
          <span>
            <div style={{ color: "black" }}>
              {/* {"$" + parseFloat(price).toFixed(2)} */}
              <NumberFormat
                value={parseFloat(price).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Total</div>,
        dataIndex: "totalAmt",
        key: "totalAmt",
        render: (total) => (
          <span>
            <div style={{ color: "black" }}>
              <NumberFormat
                value={parseFloat(total).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
              {/* {total?"$" + total.toFixed(2):"0"} */}
            </div>
          </span>
        ),
      },
    ];
    return (
      <div style={{ margin: "40px 80px" }}>
        <Spin spinning={this.state.dataLoadingStatus}>
          <Row gutter={20}>
            <Col lg={6} md={6} sm={24} xs={24}>
              <div className="site-card-border-less-wrapper">
                <Card
                  title={
                    "Order: #" +
                    (this.state.leadData["orderId"]
                      ? this.state.leadData["orderId"]
                      : "")
                  }
                  extra={
                    "PO: #" +
                    (this.state.leadData["poNumber"]
                      ? this.state.leadData["poNumber"]
                      : "")
                  }
                  description="www.instagram.com"
                  className="ordercard"
                >
                  {/* <Meta title="Europe Street beat" description="www.instagram.com" /> */}
                  <Row>
                    <div>
                      <Col lg={12} md={12} sm={24} xs={24}>
                        <p>Date & Time Ordered</p>
                        <p style={{ color: "black" }}>
                          {this.state.leadData["createdAt"] &&
                            moment(this.state.leadData["createdAt"]).format(
                              "MM/DD/YYYY"
                            ) +
                              " " +
                              moment(this.state.leadData["createdAt"]).format(
                                "hh:mm A"
                              )}
                        </p>
                      </Col>
                      <Col lg={12} md={12} sm={24} xs={24}>
                        <p>Requested Delivery Date</p>
                        <p style={{ color: "black" }}>
                          {this.state.leadData["deliveryReqDate"] &&
                            moment(
                              this.state.leadData["deliveryReqDate"]
                            ).format("MM/DD/YYYY") +
                              " " +
                              this.state.leadData["deliveryReqTime"]}
                        </p>
                      </Col>
                      <Divider />
                      <Col lg={24} md={24} sm={24} xs={24}>
                        <p>Notes</p>
                        <p style={{ color: "black" }}>
                          {this.state.leadData["notes"] &&
                            this.state.leadData["notes"]}
                        </p>
                        <Divider />
                      </Col>
                      <p style={{ fontWeight: "bold" }}>Carrier Details</p>
                      {this.state.leadData["carrierDetails"] ? (
                        <div>
                          {/* <Col lg={12} md={12} sm={24} xs={24}>
                                            <p>TRUCKING COMPANY NAME</p>
                                        </Col> */}
                          <Row>
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <p>Name</p>
                              <p style={{ color: "black" }}>
                                {
                                  this.state.leadData["carrierDetails"][
                                    "carrierName"
                                  ]
                                }
                              </p>
                              {/* <p style={{ color: "black" }}>Tri-Axle</p> */}
                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <p>Type of Truck</p>
                              <p style={{ color: "black" }}>
                                {this.state.leadData["deliveryTruck"]}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <p>Load Pickup Date</p>
                              <p style={{ color: "black" }}>
                                {this.state.leadData["pickupDate"]
                                  ? this.state.leadData["pickupDate"]
                                  : " ----- "}
                              </p>
                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <p>Delivery Date & Time</p>
                              <p style={{ color: "black" }}>
                                {this.state.leadData["deliveryDateAndTime"]
                                  ? this.state.leadData["deliveryDateAndTime"]
                                  : " ----- "}
                              </p>
                            </Col>
                          </Row>

                          <p style={{ fontWeight: "bold" }}>Carrier Contacts</p>
                          <Col lg={12} md={12} sm={24} xs={24}>
                            <p style={{ color: "#ff4700" }}>
                              <img
                                src={truckicon}
                                alt="Doc"
                                style={{ width: "20px" }}
                              />
                              &nbsp;
                              {this.state.carrierData["companyName"]
                                ? this.state.carrierData["companyName"]
                                : "-----------"}
                            </p>
                          </Col>
                          <Col lg={12} md={12} sm={24} xs={24}>
                            <p style={{ color: "#ff4700" }}>
                              <PhoneFilled style={{ fontSize: "1.2em" }} />
                              &nbsp;
                              {this.state.carrierData["phone"]
                                ? formatPhoneNumber(
                                    this.state.carrierData["phone"]
                                  )
                                : "-----------"}
                            </p>
                          </Col>
                        </div>
                      ) : (
                        <p>Carrier is not yet Assigned</p>
                      )}

                      <Divider />
                      <h2
                        style={{
                          textAlign: "center",
                          textDecoration: "underline",
                          color: "#ff4700",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          this.reOrder();
                        }}
                      >
                        Re-Order
                      </h2>
                      {this.state.leadData["orderStatus"] &&
                        (this.state.leadData["orderStatus"] === "P" ||
                          this.state.leadData["orderStatus"] === "N") && (
                          <Row>
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <h2
                                style={{
                                  textAlign: "center",
                                  textDecoration: "underline",
                                  color: "#0E4D90",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  this.editOrder();
                                }}
                              >
                                Edit-Order
                              </h2>
                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>
                              <h2
                                style={{
                                  textAlign: "center",
                                  textDecoration: "underline",
                                  color: "#ff4700",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure you want to cancel this order?"
                                    )
                                  )
                                    this.cancelOrder();
                                }}
                              >
                                Cancel Order
                              </h2>
                            </Col>
                          </Row>
                        )}
                    </div>
                  </Row>
                </Card>
              </div>
            </Col>
            <Col lg={18} md={18} sm={24} xs={24}>
              <Col lg={24} md={24} sm={24} xs={24}>
                <div className="site-card-border-less-wrapper">
                  <Card style={{ borderRadius: "10px" }}>
                    <div>
                      <Row>
                        <h1 style={{ float: "left", color: "#0E4D90" }}>
                          Order
                        </h1>

                        {this.state.leadData["orderStatus"] &&
                          (this.state.leadData["orderStatus"] === "P" ||
                            this.state.leadData["orderStatus"] === "N") && (
                            <>
                              <p
                                style={{
                                  float: "right",
                                  textDecoration: "underline",
                                  color: "#ff4700",
                                  cursor: "pointer",
                                  marginRight: "10px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure you want to cancel this order?"
                                    )
                                  )
                                    this.cancelOrder();
                                }}
                              >
                                Cancel Order
                              </p>
                              &nbsp;&nbsp;
                              <p
                                style={{
                                  float: "right",
                                  textDecoration: "underline",
                                  color: "#0E4D90",
                                  cursor: "pointer",
                                  marginRight: "10px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  this.editOrder();
                                }}
                              >
                                Edit-Order
                              </p>
                              &nbsp;&nbsp;
                            </>
                          )}
                        {/* <p style={{ float: "right", textDecoration: "underline", color: "#ff4700" }}>Re-Order</p> */}
                      </Row>
                      <Table
                        columns={columns}
                        dataSource={
                          this.state.leadData["cartItems"]
                            ? this.state.leadData["cartItems"]
                            : this.state.leadData["items"]
                            ? this.state.leadData["items"]
                            : []
                        }
                        pagination={false}
                        rowKey={(record) => record.id}
                        loading={this.state.dataLoadingStatus}
                        style={{ marginTop: "2%", overflowX: "auto" }}
                      />
                      <div style={{ marginTop: "2%" }}>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <p
                            style={{
                              color: "black",
                              fontSize: "15px",
                              float: "left",
                            }}
                          >
                            Status:&nbsp;
                            <span className="status_tag">
                              {/* <Tag color={this.state.leadData["orderStatus"] === "N" ? "red" : this.state.leadData["orderStatus"] === "P" ? 'orange' : this.state.leadData["orderStatus"] === "PC" ? 'geekblue' : this.state.leadData["orderStatus"] === "AC" ? "yellow" : "green"} key={this.state.leadData["orderStatus"]}>
                                                        {this.state.leadData["orderStatus"] === "N" ? "Order Placed" : this.state.leadData["orderStatus"] === "P" ? "In Progress" : this.state.leadData["orderStatus"] === "D" ? "Delivered" : this.state.leadData["orderStatus"] === "PC" ? "Order Processed" : "Assigned to carrier"}
                                                    </Tag> */}
                              <Tag
                                color={
                                  AppConfigs["STATUS_COLORS"][
                                    this.state.leadData["orderStatus"]
                                  ]
                                }
                                style={{
                                  color: "black",
                                  height: "27px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                }}
                              >
                                {
                                  AppConfigs["DISPLAY_LEAD_STATUS"]["customer"][
                                    this.state.leadData["orderStatus"]
                                  ]
                                }
                              </Tag>
                            </span>
                          </p>
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <p style={{ float: "right" }}>
                            Total amount:&nbsp;
                            <span style={{ color: "black", fontSize: "15px" }}>
                              {this.state.leadData["totalAmt"] && (
                                <NumberFormat
                                  value={parseFloat(
                                    this.state.leadData["totalAmt"]
                                  ).toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"$"}
                                />
                              )}
                            </span>
                          </p>
                        </Col>
                      </div>
                    </div>
                  </Card>
                </div>
              </Col>
              <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: "4%" }}>
                <div className="site-card-border-less-wrapper">
                  <Card style={{ borderRadius: "10px" }}>
                    <div>
                      <h1 style={{ color: "#0E4D90" }}>Timeline</h1>
                      <Row style={{ marginTop: "" }}>
                        <Col lg={15} md={15} sm={24} xs={24}>
                          <Steps direction="vertical" current={5}>
                            <Step
                              title={
                                <div style={{ color: "#1890ff" }}>
                                  Order Placed
                                </div>
                              }
                              icon={<DiffOutlined />}
                            />
                            {(this.state.leadData["pushToCarrier"] === true ||
                              AppConfigs["ORDER_PROCESSED"] ===
                                this.state.leadData["orderStatus"]) && (
                              <Step
                                title={
                                  <div style={{ color: "#1890ff" }}>
                                    {
                                      AppConfigs["DISPLAY_LEAD_STATUS"][
                                        "customer"
                                      ]["PC"]
                                    }
                                  </div>
                                }
                                icon={<DiffOutlined />}
                              />
                            )}
                            {this.state.leadData["assignCarrier"] && (
                              <Step
                                title={
                                  <div style={{ color: "#1890ff" }}>
                                    {
                                      AppConfigs["DISPLAY_LEAD_STATUS"][
                                        "customer"
                                      ]["AC"]
                                    }
                                  </div>
                                }
                                icon={<CodeSandboxOutlined />}
                              />
                            )}
                            {AppConfigs["IN_PROGRESS"] ===
                              this.state.leadData["orderStatus"] && (
                              <Step
                                title={
                                  <div style={{ color: "#1890ff" }}>
                                    {
                                      AppConfigs["DISPLAY_LEAD_STATUS"][
                                        "customer"
                                      ]["I"]
                                    }
                                  </div>
                                }
                                icon={<CarOutlined />}
                              />
                            )}
                            {AppConfigs["DELIVERED"] ===
                              this.state.leadData["orderStatus"] && (
                              <Step
                                title={
                                  <div style={{ color: "#1890ff" }}>
                                    {
                                      AppConfigs["DISPLAY_LEAD_STATUS"][
                                        "customer"
                                      ]["D"]
                                    }
                                  </div>
                                }
                                icon={<CheckSquareOutlined />}
                              />
                            )}
                          </Steps>
                        </Col>
                        <Col lg={9} md={9} sm={24} xs={24}>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            <p style={{ float: "right" }}>
                              {this.state.leadData["createdAt"] &&
                                moment(this.state.leadData["createdAt"]).format(
                                  "MMM Do, hh:mm A "
                                )}
                            </p>
                          </Col>
                          {(this.state.leadData["pushToCarrier"] === true ||
                            AppConfigs["ORDER_PROCESSED"] ===
                              this.state.leadData["orderStatus"]) &&
                            this.state.leadData["orderProcessedTime"] && (
                              <Col lg={24} md={24} sm={24} xs={24}>
                                <p style={{ float: "right", marginTop: "3%" }}>
                                  {moment(
                                    this.state.leadData["orderProcessedTime"]
                                  ).format("MMM Do, hh:mm A ")}
                                </p>
                              </Col>
                            )}
                          {this.state.leadData["assignCarrier"] &&
                            this.state.leadData["assignDateTime"] && (
                              <Col lg={24} md={24} sm={24} xs={24}>
                                <p style={{ float: "right", marginTop: "3%" }}>
                                  {moment(
                                    this.state.leadData["assignDateTime"]
                                  ).format("MMM Do, hh:mm A ")}
                                </p>
                              </Col>
                            )}
                          {AppConfigs["DELIVERED"] ===
                            this.state.leadData["orderStatus"] && (
                            <Col lg={24} md={24} sm={24} xs={24}>
                              <p style={{ float: "right", marginTop: "3%" }}>
                                {moment(
                                  this.state.leadData["deliveryDateAndTime"]
                                ).format("MMM Do, hh:mm A ")}
                              </p>
                            </Col>
                          )}
                          {/*<Col lg={24} md={24} sm={24} xs={24}>
                                                    <p style={{ float: "right", marginTop: "8%" }}>Nov 3, at 4:15 PM</p>
                                                </Col>
                                                <Col lg={24} md={24} sm={24} xs={24}>
                                                    <p style={{ float: "right", marginTop: "8%" }}>Nov 3, at 4:15 PM</p>
                                                </Col> */}
                        </Col>
                        <Col lg={24} md={24} sm={24} xs={24}>
                          {this.state.orderDocument &&
                          this.state.orderDocument ? (
                            <Row>
                              <Col lg={15} md={15} sm={24} xs={24}>
                                <Steps direction="vertical" current={1}>
                                  <Step
                                    title={
                                      <div
                                        style={{
                                          color: "#1890ff",
                                          fontSize: "16px",
                                        }}
                                      >
                                        Order Document
                                      </div>
                                    }
                                    icon={
                                      <DropboxOutlined
                                        style={{
                                          color: "#1890ff",
                                          fontSize: "24px",
                                        }}
                                      />
                                    }
                                  />
                                </Steps>
                              </Col>
                              <Col lg={9} md={9} sm={24} xs={24}>
                                <div style={{ float: "right" }}>
                                  <img
                                    src={
                                      this.state.orderDocument &&
                                      this.state.orderDocument.includes(".pdf")
                                        ? Docsample
                                        : this.state.orderDocument
                                    }
                                    // src={this.state.orderDocument}
                                    alt="avatar"
                                    style={{
                                      width: "150px",
                                      height: "150px",
                                      objectFit: "cover",
                                      marginTop: "2%",
                                    }}
                                  />
                                  <p
                                    style={{
                                      marginTop: "10%",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                      textAlign: "center",
                                    }}
                                    onClick={() => {
                                      this.fileDownload(
                                        this.state.leadData?.cartItems[0]
                                          ?.orderDocument
                                      );
                                    }}
                                  >
                                    Download Order Document
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          ) : (
                            ""
                          )}
                        </Col>
                        <Col lg={24} md={24} sm={24} xs={24}>
                          {this.state.leadData &&
                          this.state.leadData["leadDeliveryImage"] ? (
                            <Row>
                              <Col lg={15} md={15} sm={24} xs={24}>
                                <Steps direction="vertical" current={1}>
                                  <Step
                                    title={
                                      <div
                                        style={{
                                          color: "#1890ff",
                                          fontSize: "16px",
                                        }}
                                      >
                                        Delivered Image
                                      </div>
                                    }
                                    icon={
                                      <DropboxOutlined
                                        style={{
                                          color: "#1890ff",
                                          fontSize: "24px",
                                        }}
                                      />
                                    }
                                  />
                                </Steps>
                              </Col>
                              <Col lg={9} md={9} sm={24} xs={24}>
                                <div style={{ float: "right" }}>
                                  <img
                                    src={this.state.deliveryImage}
                                    alt="avatar"
                                    style={{
                                      width: "150px",
                                      height: "150px",
                                      objectFit: "cover",
                                      marginTop: "2%",
                                    }}
                                  />
                                  <p
                                    style={{
                                      marginTop: "10%",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                      textAlign: "center",
                                    }}
                                    onClick={() => {
                                      this.fileDownload(
                                        this.state.leadData[
                                          "leadDeliveryImage"
                                        ]["delivery_pic"]
                                      );
                                    }}
                                  >
                                    Download Image
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </div>
              </Col>
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}
// export default OrderDetails;
export default withAppContext(withRouter(OrderDetails));
